export default __webpack_public_path__ + "static/media/BlogMockUp.1c300c62.jpg";